module.exports = __webpack_public_path__ + "img/btn_tixian@2x.116b23ae.png";